import { Divider, Stack } from '@mui/material';
import { FC, memo } from 'react';
import { ShipmentOrderLegRunForPlanEntity } from 'src/entities/ShipmentOrderLegRun.entity';
import { PositionEntity } from 'src/entities/PositionEntity';

import PlanningsMapOrderMarkerTooltipContentPresenter from './PlanningsMapOrderMarkerTooltipContent.presenter';

type Props = {
  position: PositionEntity;
  orderIds: number[];
  shipmentOrderLegRunEntityMap: Map<number, ShipmentOrderLegRunForPlanEntity>;
}

const PlanningsMapOrderMarkerTooltipContentsPresenter: FC<Props> = memo((
  {
    position,
    orderIds,
    shipmentOrderLegRunEntityMap
  }
) => (
  <Stack spacing={1} divider={<Divider />}>
    {orderIds.map((orderId) => (
      <PlanningsMapOrderMarkerTooltipContentPresenter
        key={[
          'PlanningsMapOrderMarkerTooltipContentsPresenter',
          'PlanningsMapOrderMarkerTooltipContentPresenter',
          orderId,
          position,
        ].join('-')}
        orderId={orderId}
        position={position}
        shipmentOrderLegRunEntityMap={shipmentOrderLegRunEntityMap}
      />
    ))}
  </Stack>
));

export default PlanningsMapOrderMarkerTooltipContentsPresenter;
